const c = {
  name: "WorldAsiaPacific",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M17.3,5c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C16.7,3.7,17.3,4.3,17.3,5z"/>
		<path class="st0" d="M9.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.3-0.6-1.3-1.2S7.3,9.7,8,9.7C8.7,9.7,9.3,10.3,9.3,11z"/>
		<path class="st0" d="M13.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C12.7,9.7,13.3,10.3,13.3,11z"/>
		<path class="st0" d="M16,12.2c0.7,0,1.2-0.6,1.2-1.2S16.7,9.7,16,9.7c-0.7,0-1.2,0.6-1.2,1.2S15.3,12.2,16,12.2z"/>
		<path class="st0" d="M21.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C20.7,9.7,21.3,10.3,21.3,11z"/>
		<path class="st0" d="M24,12.2c0.7,0,1.2-0.6,1.2-1.2S24.7,9.7,24,9.7c-0.7,0-1.2,0.6-1.2,1.2S23.3,12.2,24,12.2z"/>
		<path class="st0" d="M29.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C28.7,9.7,29.3,10.3,29.3,11z"/>
		<path class="st0" d="M32,12.2c0.7,0,1.2-0.6,1.2-1.2S32.7,9.7,32,9.7c-0.7,0-1.3,0.6-1.3,1.2S31.3,12.2,32,12.2z"/>
		<path class="st0" d="M11.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C10.7,12.7,11.3,13.3,11.3,14z"/>
		<path class="st0" d="M14,15.2c0.7,0,1.2-0.6,1.2-1.2s-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2S13.3,15.2,14,15.2z"/>
		<path class="st0" d="M19.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C18.7,12.7,19.3,13.3,19.3,14z"/>
		<path class="st0" d="M22,15.2c0.7,0,1.2-0.6,1.2-1.2s-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2S21.3,15.2,22,15.2z"/>
		<path class="st0" d="M31.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C30.7,12.7,31.3,13.3,31.3,14z"/>
		<path class="st0" d="M6,15.2c0.7,0,1.2-0.6,1.2-1.2S6.7,12.7,6,12.7c-0.7,0-1.2,0.6-1.2,1.2S5.3,15.2,6,15.2z"/>
		<path class="st0" d="M20,6.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.8,5.7,19.3,6.2,20,6.2z"/>
		<path class="st0" d="M11.3,8c0,0.7-0.6,1.2-1.2,1.2C9.3,9.2,8.8,8.7,8.8,8c0-0.7,0.6-1.2,1.2-1.2C10.7,6.7,11.3,7.3,11.3,8z"/>
		<path class="st0" d="M14,9.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C12.8,8.7,13.3,9.2,14,9.2z"/>
		<path class="st0" d="M19.3,8c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C18.7,6.7,19.3,7.3,19.3,8z"/>
		<path class="st0" d="M22,9.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C20.8,8.7,21.3,9.2,22,9.2z"/>
		<path class="st0" d="M27.3,8c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C26.7,6.7,27.3,7.3,27.3,8z"/>
		<path class="st0" d="M30,9.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C28.8,8.7,29.3,9.2,30,9.2z"/>
		<path class="st0" d="M9.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.3-0.6-1.3-1.2c0-0.7,0.6-1.2,1.3-1.2C8.7,15.7,9.3,16.3,9.3,17z"/>
		<path class="st0" d="M12,18.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C10.8,17.7,11.3,18.2,12,18.2z"
			/>
		<path class="st0" d="M17.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C16.7,15.7,17.3,16.3,17.3,17z"
			/>
		<path class="st0" d="M20,18.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.8,17.7,19.3,18.2,20,18.2z"
			/>
		<path class="st0" d="M25.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C24.7,15.7,25.3,16.3,25.3,17z"
			/>
		<path class="st0" d="M4,18.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C2.8,17.7,3.3,18.2,4,18.2z"/>
		<path class="st0" d="M11.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C10.7,18.7,11.3,19.3,11.3,20z"
			/>
		<path class="st0" d="M14,21.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C12.8,20.7,13.3,21.2,14,21.2z"
			/>
		<path class="st0" d="M19.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C18.7,18.7,19.3,19.3,19.3,20z"
			/>
		<path class="st0" d="M22,21.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C20.8,20.7,21.3,21.2,22,21.2z"
			/>
		<path class="st0" d="M7.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C6.7,18.7,7.3,19.3,7.3,20z"/>
		<path class="st0" d="M12,24.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C10.8,23.7,11.3,24.2,12,24.2z"
			/>
		<path class="st0" d="M17.3,23c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C16.7,21.7,17.3,22.3,17.3,23z"
			/>
		<path class="st0" d="M20,24.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.8,23.7,19.3,24.2,20,24.2z"
			/>
		<path class="st0" d="M5.3,23c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C4.7,21.7,5.3,22.3,5.3,23z"/>
		<path class="st0" d="M18,27.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C16.8,26.7,17.3,27.2,18,27.2z"
			/>
		<path class="st0" d="M23.3,26c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C22.7,24.7,23.3,25.3,23.3,26z"
			/>
		<path class="st0" d="M20,30.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.8,29.7,19.3,30.2,20,30.2z"
			/>
		<path class="st0" d="M25.3,29c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C24.7,27.7,25.3,28.3,25.3,29z"
			/>
		<path class="st0" d="M28,30.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C26.8,29.7,27.3,30.2,28,30.2z"
			/>
		<path class="st0" d="M23.3,32c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.3,1.2-1.3C22.7,30.7,23.3,31.3,23.3,32z"
			/>
		<path class="st0" d="M26,33.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.3-1.2-1.3c-0.7,0-1.2,0.6-1.2,1.3C24.8,32.7,25.3,33.2,26,33.2z"
			/>
		<path class="st0" d="M21.3,35c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C20.7,33.7,21.3,34.3,21.3,35z"/>
		<path class="st0" d="M24,36.2c0.7,0,1.2-0.6,1.2-1.2s-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2S23.3,36.2,24,36.2z"/>
		<path class="st0" d="M38,11.2l0.1,0.2h0C39.4,14.1,40,17,40,20c0,11-9.2,20-20,20S0.4,31.6,0,20.8c0-0.3,0-0.5,0-0.8
			c0-0.3,0-0.5,0-0.8c0.1-1.4,0.3-2.9,0.6-4.3c0.2-0.9,0.5-1.7,0.8-2.5c0.2-0.4,0.3-0.8,0.5-1.1l0-0.1c0.3-0.7,0.7-1.3,1.1-2
			c0.3-0.5,0.6-0.9,0.9-1.3c0.5-0.6,1-1.2,1.6-1.8C9.4,2.2,14.5,0,20,0s10.6,2.2,14.4,6.1c0.6,0.6,1.1,1.2,1.6,1.8
			c0.3,0.4,0.6,0.8,0.9,1.3C37.3,9.9,37.7,10.5,38,11.2z M29.3,35c0,0.2,0,0.3-0.1,0.5C34.5,32.3,38,26.6,38,20
			c0-2.7-0.6-5.4-1.8-7.8c0,0,0,0-0.1,0c0,0-0.1,0-0.2,0c-0.7,0-1.2-0.6-1.2-1.2c0-0.3,0.1-0.6,0.3-0.8c-0.2-0.3-0.4-0.7-0.7-1
			c-0.1,0-0.2,0.1-0.4,0.1c-0.7,0-1.2-0.6-1.2-1.2c0-0.2,0.1-0.4,0.1-0.5c-1.1-1.2-2.4-2.1-3.7-2.9c0.1,0.2,0.1,0.3,0.1,0.5
			c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.6,0.5-1.1,1-1.2C25.4,2.6,22.8,2,20,2c-4.9,0-9.5,1.9-12.9,5.5
			C7.2,7.6,7.3,7.8,7.3,8c0,0.7-0.6,1.2-1.2,1.2c-0.1,0-0.3,0-0.4-0.1c-0.2,0.3-0.5,0.7-0.7,1c0.2,0.2,0.3,0.5,0.3,0.8
			c0,0.7-0.6,1.2-1.2,1.2c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c-0.2,0.3-0.3,0.6-0.4,1c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2
			c0,0.1,0.1,0.2,0.1,0.4c0,0.4-0.2,0.8-0.5,1c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2c-0.3,1.1-0.5,2.2-0.5,3.3
			c0.6,0,1.2,0.6,1.2,1.2s-0.5,1.2-1.2,1.2C2.7,30.7,10.5,38,20,38c2.8,0,5.4-0.7,7.8-1.8c-0.6-0.1-1-0.6-1-1.2
			c0-0.7,0.6-1.2,1.2-1.2C28.7,33.7,29.3,34.3,29.3,35z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as WorldAsiaPacific
};
